import React from 'react'

import Reflux from 'reflux-react-16'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'

import {Alert, Button, Card, Colors, H3, P} from '../../components/UI/index.js'
import {formSpacing, FormStack, Input} from '../../components/UI/forms/index.js'
import LoadingPage from './LoadingPage.js'

export default class ResetPassword extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {password: '', password2: '', message: '', error: '', loading: false}
        this.store = LoginStore
    }

    componentDidMount() {
        document.title = 'Wachtwoord wijzigen'
    }

    onSubmit(event) {
        event.preventDefault()
        const {password, password2} = this.state
        const {token} = this.props.match.params
        this.setState({message: '', error: '', loading: true})

        if (password.length < 10) {
            this.setState({error: 'Het wachtwoord moet minstens 10 tekens bevatten.', loading: false})
        } else if (password !== password2) {
            this.setState({error: 'De ingevulde wachtwoorden komen niet overeen.', loading: false})
        } else {
            LoginActions.resetPassword(token, password, (err) => {
                if (err) {
                    this.setState({message: '', error: err, loading: false})
                } else {
                    this.setState({message: 'Je wachtwoord is gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.', error: '', loading: false})
                }
            })
        }
    }

    onClickLogin() {
        window.location = '/login'
    }

    render() {
        const {password, password2, message, error, loading, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto', background: Colors.backgroundNeutral}}>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <form style={{width: '100%', maxWidth: 474, padding: '0 12px'}} onSubmit={this.onSubmit.bind(this)}>
                        <Card shadow='true' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 450, padding: 24, marginTop: 120, marginLeft: 'auto', marginRight: 'auto'}}>
                            <img style={{maxHeight: 128, maxWidth: 256, marginBottom: 50, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                            <H3 style={{marginBottom: 36}}>Wachtwoord wijzigen</H3>

                            {!message &&
                                <>
                                    <P style={{maxWidth: 400, marginBottom: 24}}>Vul hieronder je nieuwe wachtwoord in.</P>

                                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                        <Input
                                            style={{width: '100%'}}
                                            label='Wachtwoord (minstens 10 tekens)'
                                            type='password'
                                            autoComplete='new-password'
                                            value={password}
                                            onChange={(event) => this.setState({password: event.target.value})}
                                        />

                                        <Input
                                            style={{width: '100%'}}
                                            label='Herhaal wachtwoord'
                                            type='password'
                                            autoComplete='new-password'
                                            value={password2}
                                            onChange={(event) => this.setState({password2: event.target.value})}
                                        />
                                    </FormStack>
                                </>
                            }

                            {message && <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>}
                            {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                            {!message &&
                                <Button
                                    type='submit'
                                    style={{width: '100%', marginTop: 12}}
                                    color={branding?.color || Colors.brandColor}
                                    loading={loading}
                                >
                                    Bevestigen
                                </Button>
                            }

                            <Button
                                style={{margin: 'auto', marginTop: 72}}
                                variant='text'
                                onClick={this.onClickLogin.bind(this)}
                            >
                                Inloggen
                            </Button>
                        </Card>
                    </form>
                </div>
            </div>
        )
    }
}
